// extracted by mini-css-extract-plugin
export default {"overlay":"popup_overlay__VLPPo","popup":"popup_popup__5gTEf","link":"popup_link__UreZq","button":"popup_button__A98Fq","closeButton":"popup_closeButton__3LQ2d"};